<template>

    <auth-layout title="خطا 403">

        <b-container fluid class="mt-3">
                <b-alert show>شما به این صفحه دسترسی ندارد</b-alert>

        </b-container>

    </auth-layout>
</template>

<script>
    import AuthLayout from "../layouts/AuthLayout";
    export default {
        name: "PageForbidden",
        components: {AuthLayout}
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/pages/PageForbidden.vue